// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"nh","tag":"ni","isRental":"nj","title":"nk","title2":"nl","description":"nm","cta":"nn","ratingLabel":"no","ratingLabelSmallScreen":"np","iconInHotspotVideo":"nq"};